import React,{useState,useRef,useEffect} from 'react'
import { Formik, Field } from 'formik'
import axios from 'axios'
import moment from 'moment'
import useOnclickOutside from "react-cool-onclickoutside"
import DatePicker from "react-datepicker"
import Cleave from 'cleave.js/react'
import parse from 'html-react-parser'

import { Form, Input, TextArea, Button, Select, Label, Dropdown, Dimmer, Loader, Icon, Message, Modal, Checkbox, Popup, Table, Segment } from 'semantic-ui-react'

import { WindowReload, WindowURL, WindowLocation, RouteURL } from '../../../services/redirect'
import Spinner from '../../../services/spinner'
import AlertMessage from '../../../services/alert'

import { DropdownComponent } from '../../../components/options'
import { ValidateUpdateAccount } from '../../../validations/schemaUser'
import DropzoneSingleImage from '../../../components/dropzone-single-image'


export default function AccountComponent(props){

  /*----------------------------------------
    HANDLE CLICK OUTSIDE ELEMENT
  -----------------------------------------*/

  const handleClickAway = useOnclickOutside(() => CallbackModal({close:true}));
  function CallbackModal(data){
    if(spinner||spinnerLogout){
      return false;
    }
    props.callback(data);
  }


  /*----------------------------------------
    SPINNER
  -----------------------------------------*/
  const [spinner,setspinner] = useState(false);
  const [spinnerLogout,setSpinnerLogout] = useState(false);


  /*------------------------------------------------------
    NOTIFY
    {intent:'info',settings:{onclose:true,reload:false,title:'Congratulations!',text:'Data successfully saved.'}}
  -------------------------------------------------------*/
  const [notify,setnotify] = useState(true);
  const [nofitycontent, setnofitycontent] = useState({});
  function Notifycallback(data){
    if(data.intent=='close'){
      setnotify(false);
      if(data.reload){
        WindowReload();
      }
    }
  }


  /*----------------------------------------
    FORM STATE DATA
  -----------------------------------------*/
  const buttonEl = useRef(null);
  const [buttonclick, setbuttonClick] = useState(0);
  function buttonSubmit(arg){
      setbuttonClick(arg);
      buttonEl.current.click();
  }
  const [pathUrl, setPathUrl] = useState(props.data.file);
  const [avatarDefault, setPathUrlDefault] = useState('');
  const [avatarBlank, setPathUrlBlank] = useState('');

  const [seen,setseen] = useState(false);
  const [state, setstate] = useState({
    fullname:props.data.fullname,
    email:props.data.email,
    status:props.data.status,
    phone:props.data.phone,
    type_profile:props.data.type_profile,
    country:props.data.country,
    description:props.data.description,
    avatar:props.data.file_image,
    password:'',
    is_password:0,
    file:props.data.file,
    file_name:props.data.file_name,
    file_url:props.data.file_url,
  });



  function handleSubmitForm(values, props){

    setspinner(true);

    let formData = new FormData();
    formData.append('type','account');
    formData.append('info',JSON.stringify(values));
    formData.append('file',values.file);
    axios.post('/auth/request.php',formData)
    .then(function (response) {
      let obj = response.data;

      setspinner(false);
      setSpinnerLogout(false);


      if(obj=='success'){
        setnofitycontent({intent:'success',settings:{onclose:true,reload:false,title:'Congratulations!',text:'Data successfully saved.'}});
        setnotify(true);
        setTimeout(function() {
          WindowReload();
          setnotify(false);
        },2000);
        return false;
      }


      if(obj=='error'){
        setnofitycontent({intent:'error',settings:{onclose:true,reload:false,title:'Something Wrong!',text:'Failed to connect through the server.'}});
        setnotify(true);
        setTimeout(function() {setnotify(false);},3000);
        return false;
      }

      setnofitycontent({intent:'error',settings:{onclose:true,reload:false,title:'Input Error!',text:'Please correct the required fields.'}});
      setnotify(true);
      setTimeout(function() {setnotify(false);},3000);

      Object.keys(obj).forEach(function(key) {
        props.setErrors(obj);
      });


    })
    .catch(function (error){
      setspinner(false);
      setSpinnerLogout(false);
      setnofitycontent({intent:'error',settings:{onclose:true,reload:false,title:'Server Error!',text:'Failed to connect through the server.'}});
      setnotify(true);
      setTimeout(function() {setnotify(false);},3000);
    });
  }


  /*------------------------------------------------------
          DROPDOWN OPTIONS
  -------------------------------------------------------*/
  const [statusDropdown, setStatusDropdown] = useState([]);
  const [countryOption, setCountryOption]   = useState([]);
  const [profileOption, setProfileOptions]  = useState([]);
  const [avatar, setAvatar]  = useState([]);
  const HandleOptions = async () => {
    const source = await DropdownComponent();
    setStatusDropdown(source.status);
    setCountryOption(source.country);
    setProfileOptions(source.profileType);
    setAvatar(source.avatar);

    //setPathUrl(source.avatarImg);
    setPathUrlDefault(source.avatarImg);
    setPathUrlBlank(source.avatarBlank);

  }

  /*------------------------------------------------------
        HANDLE LOGOUT
  -------------------------------------------------------*/
  function Logout(){

    setSpinnerLogout(true);
    let formData = new FormData();
    formData.append('type','logout');
    axios.post('/auth/request.php',formData)
    .then(function (response) {
      let obj = response.data;

      setnofitycontent({intent:'success',settings:{onclose:true,reload:false,title:'Congratulations!',text:'Successfully logout'}});
      setnotify(true);
      setTimeout(function() {
        WindowReload();
        setnotify(false);
      },2000);
      return false;


    })
    .catch(function (error){
      setspinner(false);
      setSpinnerLogout(false);
      setnofitycontent({intent:'error',settings:{onclose:true,reload:false,title:'Server Error!',text:'Failed to connect through the server.'}});
      setnotify(true);
      setTimeout(function() {setnotify(false);},3000);
    });

  }


  useEffect(()=>{
      HandleOptions();
  },[]);


  return (
    <React.Fragment>

    <Formik
        initialValues={state}
        validationSchema={ValidateUpdateAccount}
        onSubmit={handleSubmitForm}
        render={formProps => {
        const { values, isSubmitting, errors, handleChange, handleBlur, handleSubmit, isValid, dirty, touched, setFieldValue } = formProps

        function SetFileImage(file){
          setFieldValue('file',file);
        }
        function SetFilePath(file){
          if(file=='no_image'){
            setPathUrl(avatarBlank);
          }else{
            setPathUrl(file);
          }
        }

        return(
           <Form>
            <div className="modalpanel-wrapper top">
              <div className="modalpanel-container tiny right animate__animated animate__slideInRight animate__faster" ref={handleClickAway}>

              {notify&&<AlertMessage data={nofitycontent} callback={Notifycallback}/>}


              {/*---------------------------------------------------------
                 HEADER
                --------------------------------------------------------*/}
                 <div className="modalpanel-header">
                    <div><h2>Account</h2></div>
                    <div onClick={()=>CallbackModal({close:true})}><i className="uil-multiply"></i></div>
                 </div>


                 {/*---------------------------------------------------------
                    BODY
                   --------------------------------------------------------*/}

                 <div className="modalpanel-body">
                    <div className="modalpanel-content">

                      <div className="accountWrapper">
                         <div><img src={pathUrl}/></div>
                         <div>
                            <Form.Group widths="equal">
                              <Field name="type_profile">
                                {({ field, form }) => (
                                    <Form.Field className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
                                      <Select selectOnBlur={false}
                                          {...field}
                                          options={profileOption}
                                          onChange={(e, { value }) => {
                                            if(value==1){
                                              setPathUrl(avatarDefault);
                                            }else{
                                              if(values.file_name!=''){
                                                setPathUrl(values.file_url);
                                              }else{
                                                setPathUrl(avatarBlank);
                                              }
                                            }
                                            setFieldValue(field.name,value);
                                          }}/>
                                      { form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
                                    </Form.Field>
                                )}
                              </Field>
                            </Form.Group>
                            {values.type_profile==1&&<div className="avatarWrapper account">
                              {avatar.map(function(data, key){
                                return <div><img src={data.text} key={key} onClick={()=>{
                                    setFieldValue('avatar',data.value);
                                    setPathUrl(data.text);
                                }}/></div>
                              })}
                            </div>}
                            {values.type_profile==2&&<Form.Group widths="equal">
                              <Field name="file">
                                  {({ field, form }) => (
                                  <Form.Field className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
                                    <DropzoneSingleImage mockdata={state} data={SetFileImage} path={SetFilePath}/>
                                    { form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
                                  </Form.Field>
                                  )}
                              </Field>
                            </Form.Group>}
                          </div>
                       </div>



                        <Form.Group widths="equal">
                          <Field name="email">
                              {({ field, form }) => (
                              <Form.Field className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
                                <label>Email</label>
                                <Input {...field} onChange={handleChange} icon="uil-envelope-alt"/>
                                { form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
                              </Form.Field>
                              )}
                          </Field>
                        </Form.Group>
                        <Form.Group widths="equal">
                          <Field name="password">
                              {({ field, form }) => (
                              <Form.Field className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
                                <label>Password</label>

                                <Input
                                  type={seen==true?'text':'password'}
                                  icon={<Icon name={seen==true?'eye':'eye slash'} link onClick={()=>setseen(seen==true?false:true)}/>}
                                  fluid {...field}
                                  disabled={values.is_password==0}
                                  onChange={handleChange} autoComplete="off"/>

                                { form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
                              </Form.Field>
                              )}
                          </Field>
                        </Form.Group>

                        <div className="box-checkbox">
                          <Form.Group widths="equal">
        										<Form.Field>
        												<Field name="is_password">
        														{({ field, form }) => (
        														<Form.Field className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
        															<Checkbox id='is_password' label='Tick the box if you want to update your password.'
        																onChange={e => {
        																	if(e.target.checked){
        																		setFieldValue('is_password',1);
        																	}else{
        																		setFieldValue('password','');
        																		setFieldValue('is_password',0);
        																	}
        																}}
        															/>
        															{ form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="fa fa-exclamation-triangle"></i>{form.errors[field.name]}</Label> }
        														</Form.Field>
        														)}
        												</Field>
        										</Form.Field>
        									</Form.Group>
                        </div>


                        <Form.Group widths="equal">
                            <Field name="fullname">
                                {({ field, form }) => (
                                <Form.Field className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
                                  <label>Fullname</label>
                                  <Input {...field} onChange={handleChange}/>
                                  { form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
                                </Form.Field>
                                )}
                          </Field>
                        </Form.Group>
                          <Form.Group widths="equal">
                            <Field name="phone">
                                  {({ field, form }) => (
                                  <Form.Field className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
                                    <label>Phone</label>
                                    <Input {...field} onChange={handleChange}/>
                                    { form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
                                  </Form.Field>
                                  )}
                            </Field>
                        </Form.Group>

                        <Form.Group widths="equal">
                          <Field name="country">
                            {({ field, form }) => (
                                <Form.Field className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
                                  <label>Country</label>
                                  <Select
                                  search
                                  selectOnBlur={false}
                                      {...field}
                                      options={countryOption}
                                      onChange={(e, { value }) => setFieldValue(field.name,value)}/>
                                  { form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
                                </Form.Field>
                            )}
                          </Field>
                        </Form.Group>


                        <Form.Group widths="equal">
                            <Field name="description">
                                {({ field, form }) => (
                                <Form.Field className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
                                  <label>Description</label>
                                  <TextArea {...field} onChange={handleChange}/>
                                  { form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
                                </Form.Field>
                                )}
                          </Field>
                        </Form.Group>

                    </div>
                 </div>


                 {/*---------------------------------------------------------
                    FOOTER
                   --------------------------------------------------------*/}

                 <div className="modalpanel-footer right">
                 
                     <Button loading={spinner} disabled={spinner||spinnerLogout} className='GreenButton uppercase strong' size='small' icon='uil-user icon'  content='Update' onClick={() => buttonSubmit(1)}/>
                     <Button loading={spinnerLogout} disabled={spinner||spinnerLogout} className="RedButton uppercase strong" size='small' content='LOGOUT' icon='sign-out' labelPosition='right' onClick={() => Logout()}/>
                     <button type="button" className="display_none" ref={buttonEl} onClick={handleSubmit}></button>
                 </div>



              </div>{/*.modalpanel-container*/}
            </div>
          </Form>
        )}}/>
    </React.Fragment>
  )
}
